/**
 * TemplateChooser — Template selection screen for first-time config creation
 *
 * Shows 2-3 starter templates plus "Start from Scratch".
 * Selecting a template pre-fills the wizard with realistic placeholder values.
 */

import React from 'react';
import { TEMPLATES } from './utils/templates';

export default function TemplateChooser({ onSelect }) {
  return (
    <div className="page">
      <div className="page-header" style={{ textAlign: 'center', marginBottom: '32px' }}>
        <h1 className="page-title">Create Your First Config</h1>
        <p className="page-subtitle">
          Choose a template to get started quickly, or start from scratch.
        </p>
      </div>

      <div className="config-template-grid">
        {TEMPLATES.map(template => (
          <div
            key={template.id}
            className="config-template-card"
            onClick={() => onSelect(template)}
            role="button"
            tabIndex={0}
            onKeyDown={e => e.key === 'Enter' && onSelect(template)}
          >
            <div className="config-template-icon">{template.icon}</div>
            <div className="config-template-name">{template.name}</div>
            <div className="config-template-desc">{template.description}</div>
          </div>
        ))}

        {/* Start from Scratch */}
        <div
          className="config-template-card config-template-scratch"
          onClick={() => onSelect(null)}
          role="button"
          tabIndex={0}
          onKeyDown={e => e.key === 'Enter' && onSelect(null)}
        >
          <div className="config-template-icon" style={{ opacity: 0.4 }}>+</div>
          <div className="config-template-name" style={{ opacity: 0.6 }}>Start from Scratch</div>
          <div className="config-template-desc" style={{ opacity: 0.4 }}>Empty config</div>
        </div>
      </div>
    </div>
  );
}
